import FundOpportunity from '../../../models/FundOpportunity';
import Contact from '../../../models/Contact';
import { Palette } from 'Palette';
import type { PromotionPrerequisiteIssue } from '../../../services/BaseBackendService';

export interface FundOpportunityWithInvestor extends FundOpportunity {
  investor?: {
    id: string;
    contactId?: string;
    status?: string;
    eoiSubmitted?: boolean;
    indicativeInvestment?: number;
    preferredInvestment?: number;
    committedInvestment?: number;
  };
}

export interface ContactFundOpportunityKanbanState {
  fundOpportunities: FundOpportunityWithInvestor[];
  loading: boolean;
  loaded: boolean;
  error?: string;
  opportunityFilter: string;
  investmentPromptOpen?: boolean;
  investmentPromptLabel?: string;
  investmentPromptValue?: string;
  investmentPromptResolver?: (amount: number) => void;
  investmentPromptError?: string;
  assignOpportunityModalOpen?: boolean;
  promotionPrerequisiteModalOpen?: boolean;
  promotionPrerequisiteIssues?: PromotionPrerequisiteIssue[];
  promotionPrerequisiteRetry?: () => Promise<void>;
  promotionPrerequisiteOnSuccess?: () => void;
  promotionPrerequisiteConfirmInProgress?: boolean;
}

export interface ContactFundOpportunityKanbanProps {
  contactId: string;
  contact?: Contact | null;
  onError: (message: string) => void;
  onSuccess?: (message: string) => void;
  onWarning?: (message: string) => void;
  onReloadContact?: () => void;
  tone?: keyof typeof Palette;
}

export const PIPELINE_STATUSES = [
  'NEW',
  'APPROVED',
  'EOI',
  'APPLICATION_OPEN',
  'UNDER_MANAGEMENT',
  'COMPLETE',
] as const;
